import store from '../../../store/store';
import { BaseComponent } from '../../base-component/base-component';
import { connect } from 'pwa-helpers';
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';
import { DownloadType } from '../../../common/utils/downloader/interfaces/downloader.interface';
import '../../product-catalog-download/product-catalog-download';
import '../../search/search-results-sorting';
import '../../search/search-results-view';

@customElement('mhecomm-print-catalog-search-results-options')
export class PrintCatalogSearchResultsOptions extends connect(store)(BaseComponent) {
  @property({ type: String })
  fileName = 'product-catalog';

  /**
   * An array of download types.
   */
  @property({ type: Array })
  downloadTypes?: DownloadType[] = [DownloadType.PDF, DownloadType.CSV, DownloadType.XLSX];

  /**
   * The prefix to be used for the download label.
   */
  @property()
  downloadLabelPrefix = 'Save as .';

  /**
   * An array of headers for CSV/XLSX download.
   */
  @property({ type: Array })
  csvXlsxHeaders?: string[] = ['Title', 'Grade', 'Program Id', 'MHID', 'ISBN13', 'Price'];

  renderComp() {
    return html`
      <div class="d-flex gap-2 align-items-end">
        <mhecomm-search-results-sorting
          id="print_catalog_sort_options"
          data-automation-id="print_catalog_sort_options"
          class="flex-grow-1"
        ></mhecomm-search-results-sorting>
        <mhecomm-search-results-view
          id="print_catalog_view_options"
          data-automation-id="print_catalog_view_options"
          titleClass="fw-bold mb-1 h6"
          color="primary"
          selectorStyle="fill"
        ></mhecomm-search-results-view>
        <div class="align-self-end">
          <mhecomm-product-catalog-download
            .downloadTypes=${this.downloadTypes}
            .csvXlsxHeaders=${this.csvXlsxHeaders}
            .downloadLabelPrefix=${this.downloadLabelPrefix}
            .fileName=${this.fileName}
          >
          </mhecomm-product-catalog-download>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-print-catalog-search-results-options': PrintCatalogSearchResultsOptions;
  }
}
